import { SubmitToSandboxSettingsFormController } from '../controller/SubmitToSandboxSettingsFormController';
import { BaseWebComponentElement } from '../../../../../framework/BaseWebComponentElement';

export class SubmitToSandboxSettingsFormWebComponent extends BaseWebComponentElement {
  constructor() {
    super();
    this.initialSetup({
      controllerConstructor: SubmitToSandboxSettingsFormController,
    });
  }

  public getFormValue(): string[] {
    return this.controller?.view.dom.$inputGrid.getFormValue() ?? [];
  }
}
